import { Box, Button, Grid, Typography } from "@mui/material";
import { extraServiceData } from "common/constants/extra-service-info";
import LazyImage from "components/LazyImage";
import useWindowSizeV2 from "hooks/use-window-size-v2";
import { FC, Fragment, memo } from "react";

type Props = { onScroll: () => void };

const Component: FC<Props> = ({ onScroll }) => {
  const { isMobile } = useWindowSizeV2();

  return (
    <Fragment>
      {extraServiceData.map((item, index) => (
        <Grid key={index} container>
          <Grid
            item
            xs={12}
            lg={6}
            order={{ xs: 1, lg: index % 2 === 0 ? 1 : 2 }}
            sx={{ display: "grid", placeContent: "center" }}
          >
            <LazyImage
              sx={{
                width: "100%",
                borderRadius: "8.8px",
                border: "2px solid red",
              }}
              width={550}
              height={550}
              alt={`${item?.title}-img`}
              loading="eager"
              objectFit="contain"
              src={item?.img}
            />
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            order={{ xs: 2, lg: index % 2 === 0 ? 2 : 1 }}
            sx={{ display: "grid", placeContent: "center" }}
          >
            <Typography variant="h4" fontWeight={900} mb={1.5}>
              {item?.title}
            </Typography>
            <Typography
              fontSize={{ xs: "16px", lg: "24px" }}
              textAlign={"justify"}
              lineHeight={{ xs: "32px", lg: "42px" }}
            >
              {item?.content}
            </Typography>

            <Box>
              <Button
                variant="outlined"
                sx={{
                  mt: 3,
                  borderRadius: "45px",
                  color: "#1D72B0",
                  fontSize: "16px",
                }}
                onClick={onScroll}
              >
                Learn More
              </Button>
            </Box>
          </Grid>
        </Grid>
      ))}
    </Fragment>
  );
};

export const ExtraServiceOffers = memo(Component);
